export default {
    failedToRemoveProductsDueToLoadedContainer: "Failed to remove due to selected {{no}} products already loaded to containers",
    atLeast1ProductIsRequired: "At least one product is required",
    added1NewProductEntry: 'Added (1) new product entry',
    selected1Item: 'Selected (1) item',
    added1NewItemEntry: 'Added (1) new item entry',
    thereAreSomeProductsAlreadyLoadedToTheContainers: 'There are some products already loaded to the containers',
    itemsAtLeastHave1Row: 'Items at least have (1) row',
    pleaseSelectAllTheShippingRatesToProceed: 'Please select all the shipping rates to proceed',
    mustSelectAtLeast1Selection: 'Must select at least (1) selection',
    pleaseSelectContainer: 'Please select Container!',
    thereIsNotItemsRelatedToThisContainer: 'There is not items related to this container',
    supplierOrContainerAreNotYetSelectedPleaseSelectBothForNextStep: 'Supplier or Container are not yet selected. Please select both for next step!',
    youHaveToSelectTheFullQtyIfThereIsNotSplitOption: 'You have to select the full qty if there is not split option',
    youHaveToSelectTheQtyAtLeastMoreThan1Qty: 'You have to select the qty at least more than 1 qty',
    selectedProductHasNotSyncToHQYet: 'Selected product has not sync to HQ yet',
    onlySelect1ProductToProceed: 'Only select (1) product to proceed',
    selectedProductHasBeenLoadedToContainer: 'Selected product has been loaded to container',
    selectedProductQtyHasChanged: 'Selected product qty has changed, please refresh and try again',
    pleaseSelectAtLeast1DataFilter: 'Please select at least (1) data filter',
    savedSuccess: 'Changes saved',
    productAddedToContainer: 'New product added to container',
    removeFromContainerSuccess: 'Selected products unassigned from container',
    productsSuccessDeleted: 'Selected Products Deleted'
}